import { Row } from "react-bootstrap";
import { styled } from "styled-components";

export const MetaBarWrapper = styled(Row)`
  align-items: end;
  border-bottom: 1px solid ${(props) => props.theme.colours.primary.greyShade};
`;
